module.exports = __webpack_public_path__ + "img/mcedge.98c781e5.gif";